module.exports = __webpack_public_path__ + "img/dayungs_logo.08735f87.png";